export default __webpack_public_path__ + "static/power-business-3675b72b16ba72293ff736220c382d16.webp";